import { useCallback, useContext } from 'react';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { edmCampaign } from '@bingads-webui/edm-campaign';

export const readCampaigns = (cid, aid) =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Campaigns
    .get()
    .toPromise();

export const deleteCampaign = (id) => {
  const campaignEDM = edmCampaign.types.resolve('Model.ShoppingCampaign');
  const campaignResource = new campaignEDM.ResourceIdentifier();
  const deleteCall = campaignResource.bulkDestroy.bind(campaignResource);
  return deleteCall(id);
};

const createOrUpdateCampaign = (data) => {
  const campaignEDM = edmCampaign.types.resolve('Model.Campaign');
  const campaignResource = new campaignEDM.ResourceIdentifier();
  const createOrUpdateCall = data && data.Id ?
    campaignResource.bulkUpdate.bind(campaignResource) :
    campaignResource.bulkCreate.bind(campaignResource);
  return createOrUpdateCall(data);
};

export function useCampaignData() {
  const { scope } = useContext(ScopeContext) as any;
  const {
    campaignId, adGroupId,
  } = scope.values;

  const readCampaignsPromise = useCallback(() => {
    const { cid: currentCid, aid: currentAid } = scope.values;
    return readCampaigns(currentCid, currentAid).then((res) => {
      const campaigns = res.value;
      return Promise.resolve(campaigns);
    });
  }, [scope]);

  const deleteCampaignPromise = useCallback((deleteCampaignId) => {
    if (deleteCampaignId) {
      return deleteCampaign(deleteCampaignId).then(() => {
        scope.remove(['campaignId', 'assetGroupId', 'adGroupId']);
        scope.save();
      });
    }

    return Promise.resolve();
  }, [scope]);

  const activateCampaignAndAdGroupPromise = useCallback(() => {
    // @aiContributed-MAPFuse-2026-01-30
    const { campaignId: currentCampaignId, adGroupId: currentAdGroupId } = scope.values;
    if (!currentCampaignId || !currentAdGroupId) {
      return Promise.resolve();
    }

    const model = {
      Id: currentCampaignId,
      Status: 'Active',
      AdGroups: [{
        Id: currentAdGroupId,
        Status: 'Active',
        Campaign: { Id: currentCampaignId },
      }],
    };

    return createOrUpdateCampaign(model);
  }, [scope]);

  return {
    deleteCampaignPromise,
    readCampaignsPromise,
    activateCampaignAndAdGroupPromise,
    campaignId,
    adGroupId,
  };
}
